module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 新建")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属学制",
      "prop": "schoolLenName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属系部",
      "prop": "deptName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属年级",
      "prop": "gradeName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属专业",
      "prop": "majorName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属班级",
      "prop": "className",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "授课教师",
      "prop": "teaName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上课时间",
      "prop": "orderTimeName",
      "formatter": _vm.timeFormatter,
      "width": "220px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.delRec(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "850px",
      "top": "120px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.curdRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写"
    },
    model: {
      value: (_vm.curdForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "courseName", $$v)
      },
      expression: "curdForm.courseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上课时间",
      "prop": "orderTimeCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.curdForm.week),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "week", $$v)
      },
      expression: "curdForm.week"
    }
  }, _vm._l((_vm.comboOption.week), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "565px"
    },
    attrs: {
      "placeholder": "请选择上课时间",
      "multiple": ""
    },
    model: {
      value: (_vm.curdForm.time),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "time", $$v)
      },
      expression: "curdForm.time"
    }
  }, _vm._l((_vm.comboOption.time), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属学制",
      "prop": "schoolLen"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "默认全部学制",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.schoolLenArray),
      callback: function($$v) {
        _vm.schoolLenArray = $$v
      },
      expression: "schoolLenArray"
    }
  }, _vm._l((_vm.comboOption.schoolLen), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属院系",
      "prop": "deptCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "默认全部院系",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleDeptChange
    },
    model: {
      value: (_vm.deptCodeArray),
      callback: function($$v) {
        _vm.deptCodeArray = $$v
      },
      expression: "deptCodeArray"
    }
  }, _vm._l((_vm.comboOption.dept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属年级",
      "prop": "gradeCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "默认全部年级",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleGradeChange
    },
    model: {
      value: (_vm.gradeCodeArray),
      callback: function($$v) {
        _vm.gradeCodeArray = $$v
      },
      expression: "gradeCodeArray"
    }
  }, _vm._l((_vm.comboOption.grade), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属专业",
      "prop": "majorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "默认全部专业",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleMajorChange
    },
    model: {
      value: (_vm.majorCodeArray),
      callback: function($$v) {
        _vm.majorCodeArray = $$v
      },
      expression: "majorCodeArray"
    }
  }, _vm._l((_vm.comboOption.major), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属班级",
      "prop": "classCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "默认全部班级",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.classCodeArray),
      callback: function($$v) {
        _vm.classCodeArray = $$v
      },
      expression: "classCodeArray"
    }
  }, _vm._l((_vm.comboOption.class), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师",
      "prop": "teaCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "可选择授课教师（班会课不选择默认为班主任）",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.teaCodeArray),
      callback: function($$v) {
        _vm.teaCodeArray = $$v
      },
      expression: "teaCodeArray"
    }
  }, _vm._l((_vm.comboOption.tea), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3af000"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/timetableManage/arrange/customCourse.vue
// module id = 1786
// module chunks = 502